import React from 'react';
import { Container, Spinner } from 'reactstrap';

// Presentational spinner shown by GuardedRoute/SkipRoute while auth state resolves.
// Guards handle navigation; this component only renders.
const Loading = () => (
  <div className="section-hero section-shaped">
    <div className="shape shape-style-2 shape-default"></div>
    <Container className="body-content">
      <Spinner />
      <h5 className="white">Just a second...</h5>
    </Container>
  </div>
);

export default Loading;
